/* eslint-disable */
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import TaskStatusOptions from "data/Prod/TaskStatus.json";
import TaskPriority from "data/Prod/TaskPriority.json";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import { reactSelectStyle } from "Config/Config";

const CrmTaskTab = (props) => {
  const {
    /* module start (eg:selectedModuleSlug=MOD_LEAD) and moduleName="projecttask*/
    selectedModuleSlug = "",
    moduleName = "",
    /* module end */

    /* select component id start */
    contactId = null,
    leadId = null,
    /* select component id end */

    /* for task details and update */
    selectedTaskId = null,
    setSelectedTaskId = () => {},
    afterPopupClose = () => {},

    /* for reset */
    isReset = false,
    setIsReset = () => {},

    /* for alert */
    setShowAlert = () => {},
    setAlertMessage = () => {},
    setMessageType = () => {},
  } = props;

  const todayValue = new Date().toISOString().split("T")[0];

  const { t } = useTranslation();
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [previousTaskInput, setPreviousTaskInput] = useState("");
  const [previousTaskListOptions, setpreviousTaskListOptions] = useState([]);

  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [taskStatusValue, settaskStatusValue] = useState(null);
  const [taskStatus, settaskStatus] = useState("");
  const [prevTaskValue, setPrevTaskValue] = useState(null);
  const [previousTaskId, setPreviousTaskId] = useState(null);
  const [hours, sethours] = useState("");
  const [price, setPrice] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [priorityValue, setpriorityValue] = useState(null);
  const [priority, setpriority] = useState("");
  const [rank, setRank] = useState(1);
  const [isMilestone, setIsMilestone] = useState(false);
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [uploadedDocFileIds, setUploadedDocFileIds] = useState([]);

  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");

  /* hooks for validation */
  const [errors, setErrors] = useState({});

  const validationHandler = () => {
    const newErrors = {};

    if (title.trim() === "") {
      newErrors.name = t("Please enter a name for the task.");
    }

    if (hours === "" || parseFloat(hours) <= 0) {
      newErrors.hours = t("Estimated hours must be a positive number.");
    }

    if (startDate === "") {
      newErrors.startDate = t("A start date is required for the task.");
    }

    if (endDate === "") {
      newErrors.endDate = t("An end date is required for the task.");
    }

    if (startDate !== "" && endDate !== "") {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start.getTime() > end.getTime()) {
        newErrors.dateRange = t(
          "The end date cannot be earlier than the start date."
        );
      }
    }

    if (!taskStatus) {
      // Simplified check
      newErrors.status = t("Please select the current status of the task.");
    }

    if (!priority) {
      // Simplified check
      newErrors.priority = t("Please set a priority level for the task.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //get all tasks for select previous task
  const getAllPreviousTask = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TASKLIST_BY_SEARCH +
        `?searchtitle=${previousTaskInput}`;

      if (leadId) {
        requestUrl += `&leadid=${leadId}`;
      }

      if (contactId) {
        requestUrl += `&contactid=${contactId}`;
      }

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in task list------->", response);

      if (response.status) {
        setpreviousTaskListOptions(response.data);
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //select status
  const statusSelectionHandler = (val) => {
    settaskStatusValue(val);
    if (
      val.value === "0" ||
      val.value === "1" ||
      val.value === "2" ||
      val.value === "3"
    ) {
      settaskStatus(val.value);
    }
  };

  //select priority
  const prioritySelectionHandler = (val) => {
    setpriorityValue(val);
    setpriority(val.value);
  };

  //select previous task
  const previousTaskSelectionHandler = (val) => {
    if (val) {
      setPrevTaskValue(val);
      setPreviousTaskId(val.value);
      setstartDate(val.enddate);
      setendDate("");
    } else {
      setPrevTaskValue(null);
      setPreviousTaskId(null);
      setpreviousTaskListOptions([]);
      // setstartDate("");
      // setendDate("");
    }
  };

  //function for upload doc files
  const docFileUploadHandler = async (docFiles) => {
    try {
      setDocFileUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD;

      const response = await uploadMultipleFile(requestUrl, docFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedDocFiles.length == 0) {
          setUploadedDocFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedDocFiles.concat(uploadedFileValues);
          setUploadedDocFiles(fileArr);
        }

        /*----- assign uploaded files with path for display end ------*/
        setDocFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedDocFileIds.length == 0) {
          setUploadedDocFileIds(fileIds);
        } else {
          let fileArr = uploadedDocFileIds.concat(fileIds);
          setUploadedDocFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
      resetDocInput();
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    const closedFile = [...uploadedDocFiles];
    const removedFileId = [...uploadedDocFileIds];
    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);
    setUploadedDocFiles(closedFile);
    setUploadedDocFileIds(removedFileId);
  };

  //get task details
  const getTaskDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TASK_DETAILS +
        `/${selectedTaskId}`;

      const response = await getData(requestUrl);

      if (response.status) {
        settitle(response.data.title);
        setIsMilestone(
          response.data.ismilestone ? response.data.ismilestone : false
        );
        setdetails(response.data.description);

        TaskStatusOptions.map((statusData) => {
          if (statusData.value == response.data.completedpercent) {
            statusSelectionHandler(statusData);
          } else {
            statusSelectionHandler(TaskStatusOptions[0]);
          }
        });

        sethours(response.data.hours ?? 0);
        setPrice(response.data.price ?? 0);
        setstartDate(response.data.startdate);
        setendDate(response.data.enddate);
        setRank(response.data.rank);

        TaskPriority.map((priorityData) => {
          if (priorityData.value === response.data.priority) {
            prioritySelectionHandler(priorityData);
          }
        });

        //assign uploaded files
        setUploadedDocFiles(
          response?.data?.uploadedfiles.map(
            ({ name, path, _id, ...other }) => ({
              name,
              path: url.SERVER_URL + path,
              _id,
            })
          )
        );

        setUploadedDocFileIds(response?.data?.uploadedfileids);

        if (response.data.previoustaskvalue) {
          setPrevTaskValue(response.data.previoustaskvalue);
          setPreviousTaskId(response.data.previoustaskvalue.value);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //save task
  const saveTaskHandler = async () => {
    if (!validationHandler()) {
      setAlertMessage(
        t("Please correct the errors highlighted above before saving.")
      );
      setMessageType("error");
      setShowAlert(true);
      seterrorMessage(
        t("Please correct the errors highlighted above before saving.")
      );
      return;
    }
    seterrorMessage("");

    try {
      setIsSaving(true);

      let taskData = {
        moduleslug: moduleName, // Use moduleName from props
        leadid: leadId, // Use leadId from props
        contact: contactId, // Use contactId from props
        project: null, // CrmTaskTab doesn't have project selection
        projectsection: null, // CrmTaskTab doesn't have section selection
        previoustask: previousTaskId,
        title,
        description: details,
        ismilestone: isMilestone,
        startdate: startDate,
        enddate: endDate,
        hours,
        price,
        priority,
        completedpercent: taskStatus,
        assigneduser: userInfo._id, // Use logged-in user's ID
        rank: rank || 1,
        uploads: uploadedDocFileIds,
      };

      let response = {};
      let requestUrl = "";

      if (selectedTaskId) {
        requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_PROJECT_TASK +
          `/${selectedTaskId}`;
        response = await putData(requestUrl, taskData);
      } else {
        requestUrl =
          url.API_BASE_URL + url.API_ADD_NEW_PROJECT_TASK;
        response = await postData(requestUrl, taskData);
      }

      setIsSaving(false);

      if (response.status) {
        setSelectedTaskId(response.data._id); // Update selectedTaskId if a new task is created
        getTaskDetails();
        setMessageType("success");
        afterPopupClose(response.data); // Call afterPopupClose with new task data
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  //reset
  const resetHandler = () => {
    settitle("");
    setdetails("");
    settaskStatusValue(null);
    settaskStatus("");
    setPrevTaskValue(null);
    setPreviousTaskId(null);
    sethours("");
    setPrice("");
    setstartDate(todayValue);
    setendDate(todayValue);
    setpriorityValue(null);
    setpriority("");
    setRank(1);
    setIsMilestone(false);
    setDocFileUploading(false);
    setUploadedDocFiles([]);
    setUploadedDocFileIds([]);
    setIsSaving(false);
    seterrorMessage("");
    setErrors({});
    setSelectedTaskId(null); // Reset selected task ID in parent
    // No need to reset setShowAlert, setAlertMessage, setMessageType here as they are props
  };

  useEffect(() => {
    if (selectedTaskId) {
      getTaskDetails();
    }
  }, [selectedTaskId]);

  useEffect(() => {
    if (isReset) {
      resetHandler();
      setIsReset(false);
    }
  }, [isReset]);

  //previous task
  useEffect(() => {
    if (previousTaskInput.length > 1) {
      getAllPreviousTask();
    }
  }, [previousTaskInput]);

  useEffect(() => {
    TaskStatusOptions.map((statusData) => {
      if (statusData.value == "0") {
        statusSelectionHandler(statusData);
      }
    });

    TaskPriority.map((priorityData) => {
      if (priorityData.value === "2") {
        prioritySelectionHandler(priorityData);
      }
    });

    setstartDate(todayValue);
    setendDate(todayValue);
  }, []);

  const customStatusStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.status ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.status ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  const customPriorityStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.priority ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.priority ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
      <form
        onSubmit={(e) => e.preventDefault()}
        className="d-flex flex-column h-100"
      >
        <div className="fields-container flex-fill">
          {/* <!-- ========== Start title Section ========== --> */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label
              htmlFor="taskName"
              className="d-block fs-sm fw-semibold mb-2 text-dark"
            >
              {t("Task Name")} <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="taskName"
              className={`form-control fs-sm shadow-none ${
                errors.name ? "is-invalid" : "border border-gray-300"
              }`}
              placeholder={t("e.g., Design new homepage mockup")}
              value={title}
              onChange={(e) => {
                settitle(e.target.value);
                if (errors.name) {
                  setErrors((prev) => ({ ...prev, name: "" }));
                }
                seterrorMessage("");
              }}
              aria-describedby="taskNameFeedback"
            />
            {errors.name && (
              <div id="taskNameFeedback" className="invalid-feedback">
                {errors.name}
              </div>
            )}
          </div>
          {/* <!-- ========== End title Section ========== --> */}

          {/* <!-- ========== Start details Section ========== --> */}
          <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
            <JoditEditorField
              label={t("Details")}
              value={details}
              onChange={(newContent) => setdetails(newContent)}
              labelClassName="d-block fs-sm fw-semibold mb-2 text-dark"
            />
          </div>
          {/* <!-- ========== End details Section ========== --> */}

          {/* hours, price and complete status */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-md-4 mb-4 mb-md-0">
                <label
                  htmlFor="time"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Time (Hours)")} <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  id="time"
                  min={1}
                  className={`form-control fs-sm shadow-none ${
                    errors.hours ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., 8")}
                  value={hours}
                  onChange={(e) => {
                    sethours(e.target.value);
                    if (errors.hours) {
                      setErrors((prev) => ({ ...prev, hours: "" }));
                    }
                    seterrorMessage("");
                  }}
                  aria-describedby="hoursFeedback"
                />
                {errors.hours && (
                  <div id="hoursFeedback" className="invalid-feedback">
                    {errors.hours}
                  </div>
                )}
              </div>
              <div className="col-md-4 mb-4 mb-md-0">
                <label
                  htmlFor="price"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Price")}
                </label>
                <input
                  type="number"
                  min={0}
                  id="price"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t("Budget")}
                  value={price}
                  onChange={(e) => {
                    setPrice(e.target.value);
                  }}
                />
              </div>
              <div className="col-md-4">
                <label
                  htmlFor="status"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Complete Status")} <span className="text-danger">*</span>
                </label>
                <Select
                  placeholder={t("Select task status")}
                  styles={customStatusStyles}
                  options={TaskStatusOptions}
                  value={taskStatusValue}
                  onChange={(val) => {
                    statusSelectionHandler(val);
                    if (errors.status) {
                      setErrors((prev) => ({ ...prev, status: "" }));
                    }
                    seterrorMessage("");
                  }}
                  aria-describedby="statusFeedback"
                />
                {errors.status && (
                  <div id="statusFeedback" className="invalid-feedback">
                    {errors.status}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* previous task and priority */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0">
                <label
                  htmlFor="previousTask"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Previous task to complete (If Any)")}
                </label>
                <Select
                  isClearable
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  placeholder={t("Search for a preceding task...")}
                  options={previousTaskListOptions}
                  value={prevTaskValue}
                  onChange={(val) => {
                    previousTaskSelectionHandler(val);
                  }}
                  onInputChange={(val) => {
                    setPreviousTaskInput(val);
                  }}
                />
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="priority"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Priority")} <span className="text-danger">*</span>
                </label>
                <Select
                  styles={customPriorityStyles}
                  placeholder={t("Select a priority level")}
                  options={TaskPriority}
                  value={priorityValue}
                  onChange={(val) => {
                    prioritySelectionHandler(val);
                    if (errors.priority) {
                      setErrors((prev) => ({ ...prev, priority: "" }));
                    }
                    seterrorMessage("");
                  }}
                  aria-describedby="priorityFeedback"
                />
                {errors.priority && (
                  <div id="priorityFeedback" className="invalid-feedback">
                    {errors.priority}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* <!-- ========== Start deadline and rank Section ========== --> */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0">
                <label
                  htmlFor="deadline"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Deadline")} <span className="text-danger">*</span>
                </label>
                <div className="field-container d-flex flex-column flex-lg-row gap-3 align-items-lg-center rounded-10">
                  <input
                    type="date"
                    id="startdate"
                    className={`form-control fs-sm shadow-none ${
                      errors.startDate ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={startDate}
                    onChange={(e) => {
                      setstartDate(e.target.value);
                      if (errors.startDate) {
                        setErrors((prev) => ({ ...prev, startDate: "" }));
                      }
                      if (errors.dateRange) {
                        setErrors((prev) => ({ ...prev, dateRange: "" }));
                      }
                      seterrorMessage("");
                    }}
                    aria-describedby="startDateFeedback"
                  />
                  <input
                    type="date"
                    id="enddate"
                    className={`form-control fs-sm shadow-none ${
                      errors.endDate ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={endDate}
                    onChange={(e) => {
                      setendDate(e.target.value);
                      if (errors.endDate) {
                        setErrors((prev) => ({ ...prev, endDate: "" }));
                      }
                      if (errors.dateRange) {
                        setErrors((prev) => ({ ...prev, dateRange: "" }));
                      }
                      seterrorMessage("");
                    }}
                    aria-describedby="endDateFeedback"
                  />
                </div>{" "}
                <div className="d-flex gap-2">
                  {errors.startDate && (
                    <div
                      id="startDateFeedback"
                      className="invalid-feedback d-block"
                    >
                      {errors.startDate}
                    </div>
                  )}
                  {errors.endDate && (
                    <div
                      id="endDateFeedback"
                      className="invalid-feedback d-block"
                    >
                      {errors.endDate}
                    </div>
                  )}
                  {errors.dateRange && (
                    <div
                      id="dateRangeFeedback"
                      className="invalid-feedback d-block"
                    >
                      {errors.dateRange}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="rank"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Rank")}
                </label>
                <input
                  type="number"
                  min={1}
                  id="rank"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t("Rank")}
                  value={rank}
                  onChange={(e) => {
                    setRank(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          {/* <!-- ========== End deadline and rank Section ========== --> */}

          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <p className="d-block fs-sm fw-semibold mb-2 text-dark">
              {t("Milestone")}
            </p>
            <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
              <input
                className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                type="checkbox"
                checked={isMilestone}
                onChange={(e) => {
                  setIsMilestone(e.target.checked);
                }}
                id="isMilestone"
              />
              <label
                className="form-check-label fw-semibold text-dark"
                htmlFor="isMilestone"
              >
                {t("Mark as Milestone")}
              </label>
            </div>
          </div>

          {/* ------ upload documnet section start ------- */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label
              htmlFor="documents"
              className="d-block fs-sm fw-semibold mb-2 text-dark"
            >
              {t("Upload Documents")}
            </label>
            <FileUploadField
              label={t("Upload Documents")}
              accept="doc mp4 pdf"
              onUpload={docFileUploadHandler}
              files={uploadedDocFiles}
              onRemove={closeDocFileHandler}
              loading={docFileUploading}
              multiple
              fileType="document"
            />
          </div>
          {/* ------ upload documnet section end ------- */}
        </div>
        <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
          <button
            onClick={saveTaskHandler}
            type="button"
            className="btn btn-primary d-flex align-items-center gap-2"
            disabled={isSaving}
            style={{
              cursor: isSaving ? "not-allowed" : "pointer",
            }}
          >
            {isSaving ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                {t("Saving...")}
              </>
            ) : (
              <>
                <span className="material-symbols-outlined me-1">save</span>{" "}
                {t("Save Task")}
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CrmTaskTab;
